export enum UpdateLpsRoutesEnum {
    MODULE_ACCESS = 'View',
    FILTER_BY_VIEW = 'Filter_by_View',
    FILTER_BY_EDIT = 'Filter_by_Edit',
    UPDATE_LPS_ROUTES_GRID_VIEW = 'Update_LPS_Routes_Grid_View',
    UPDATE_LPS_ROUTES_GRID_EDIT = 'Update_LPS_Routes_Grid_Edit',
}
